<template>
  <UError :error="error" :redirect="error.data?.redirect || '/'"
    :clear="{ label: error.data?.redirectButtonLabel || 'Înapoi' }" />
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

defineProps<{
  error: NuxtError<{
    redirect: string
    redirectButtonLabel: string
  }>
}>()
</script>
